import React from 'react';
import { MdOutlineShoppingCart } from 'react-icons/md';
import { useUiComponentsInternationalContext } from '@repo/static-translations';

import { Button, type ButtonProps } from '../../shadcn/Button';

const LargeCartButton = (props: ButtonProps) => {
  const { tt } = useUiComponentsInternationalContext();

  return (
    <Button {...props}>
      <MdOutlineShoppingCart size="24px" />
      {tt(s => s.addToCartButtonComponent.addToCartLabel)}
    </Button>
  );
};

export default LargeCartButton;
